import { createSlice } from "@reduxjs/toolkit";

const initialBooksState = {
  listLoading: false,
  actionsLoading: false,
  totalCount: 0,
  authorities: null,
  teachers: []
};

export const callTypes = {
  list: "list",
  action: "action"
};

export const studentBookSlice = createSlice({
  name: "studentBooks",
  initialState: initialBooksState,
  reducers: {
    startCall: (state, action) => {
      if (action.payload.callType === callTypes.list) {
        state.listLoading = true;
      } else {
        state.actionsLoading = true;
      }
    },
    // getBooks
    booksFetched: (state, action) => {
      const { isSuccess, type, totalCount, entities, authorities } = action.payload;
      state.listLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.entities = entities;
      state.totalCount = totalCount;
      state.authorities = authorities;
    },
    // getTeachers
    teachersFetched: (state, action) => {
      const { isSuccess, type, entities } = action.payload;
      state.actionsLoading = false;
      state.isSuccess = isSuccess;
      state.type = type;
      state.teachers = entities;
    },
    // completeAction
    actionCompleted: (state) => {
      state.actionsLoading = false;
    },
    // cleanBooksState
    booksStateCleaned: (state) => {
      state.listLoading = false;
      state.actionsLoading = false;
      state.isSuccess = undefined;
      state.type = undefined;
      state.totalCount = 0;
      state.entities = undefined;
    }
  }
});